import {
  Table,
  Pagination,
  Space,
  Popconfirm,
  Spin,
  Image,
  Select,
} from "antd";
import { DeleteFilled, EyeTwoTone, EditOutlined } from "@ant-design/icons";
import { numberSeprator } from "../../utils/number-seprator";
import PropertyPlaceholder from "../../assets/dashboard/propertyPlaceholder.png";

const Admintable = ({
  confirm,
  properties,
  currentPage,
  setCurrentPage,
  loader,
  selectedRecord,
  navigate,
  getPropertyHandler,
  cancel,
  limit,
  setLimit,
  rowSelection,
}) => {
  // Table Columns
  const columns = [
    {
      title: "images",
      dataIndex: "images",
      key: "images",
      render: (data) => (
        <Image
          width={200}
          src={(data && data[0]?.url) || PropertyPlaceholder}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PropertyPlaceholder;
          }}
        />
      ),
    },
    // {
    //   title: "Reference Number",
    //   dataIndex: "referenceNumber",
    //   key: "referenceNumber",
    //   render: (data) => <Space size="middle">{data ? data : "-"}</Space>,
    // },
    {
      title: "Title",
      dataIndex: "",
      key: "",
      render: (data) => (
        <div>
          <Space size="middle">
            <b>Reference Number: {data?.referenceNumber}</b>
          </Space>{" "}
          <br />
          <Space size="middle">{data?.title}</Space>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "saleOrRentprice",
      key: "saleOrRentprice",
      render: (data) => <Space size="middle">{numberSeprator(data)}</Space>,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (data) => (
        <Space size="middle">
          {data?.includes("_") ? data?.replace("_", " ") : data}
        </Space>
      ),
    },
    {
      title: "From CRM",
      dataIndex: "importedFromCrm",
      key: "importedFromCrm",
      render: (data) => <Space size="middle">{data ? "Yes" : "No"}</Space>,
    },
    {
      title: "Location",
      key: "address",
      dataIndex: "address",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <Space>
            {" "}
            <a
              href={`https://empireinfratech.ae/property-details/${data?.slug}`}
              target="_blank"
              rel="noreferrer"
            >
              <EyeTwoTone />
            </a>
          </Space>
          <Space className="px-4">
            <EditOutlined
              key="edit"
              className="delete-icon-admin cursor-pointer "
              onClick={() => navigate("/edit-property/" + data?._id)}
            />
          </Space>
          <div className="">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer delete-icon-admin" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={properties?.properties}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
        rowSelection={rowSelection}
        rowKey={(record) => record?._id}
      />
      {!loader && (
        <div className="pagination-container">
          <Pagination
            defaultPageSize={currentPage}
            showSizeChanger={false}
            current={currentPage}
            pageSize={limit}
            total={properties?.totalPropertys}
            onChange={(e) => {
              setCurrentPage(e);
              getPropertyHandler(e);
            }}
            className="pagination"
          />
          <Select
            options={[
              { value: 10, label: "Page limit 10" },
              { value: 20, label: "Page limit 20" },
              { value: 30, label: "Page limit 30" },
              { value: 40, label: "Page limit 40" },
              { value: 50, label: "Page limit 50" },
            ]}
            value={limit}
            onChange={(e) => {
              setLimit(e);
              setCurrentPage(1);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default Admintable;
